/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Popconfirm } from 'antd';
import {
  CloseOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import BomSelector from '@Components/Common/Selector/BomSelector';
import H3Text from '@Uilib/h3Text';
import FGInwardBatch from '../../FGInwardBatch';
import './style.scss';
import ProductCategoryLabel from '../../../../../Common/ProductCategoryLabel';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';
import BatchCustomFields from '../../../../../Common/BatchCustomFields';

/**
 *
 */
class FinishedGood extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);

    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      productListColumns: [
        {
          title: 'PRODUCT',
          width: '220px',
          render: (text, record) => {
            const {
              handleProductChange, rmTenantDepartmentId, excludedProducts, selectedTenant, handleChangeRemarks,
            } = this.props;
            return (
              <div className="mo-fg-table__product-name">
                {
                  (record?.bom_id) ? (
                    <Fragment>
                      <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`} target="_blank">
                        {`#${record?.tenant_product_info?.internal_sku_code}`}
                      </Link>
                      {record?.bom_info?.product_info?.product_category_info &&
                      record?.bom_info?.product_info?.product_category_info?.category_path?.length > 0 && (
                      <ProductCategoryLabel
                        categoryPath={record?.bom_info?.product_info?.product_category_info?.category_path}
                        categoryName={record?.bom_info?.product_info?.product_category_info?.category_path?.at(
                          -1
                        )}
                        containerStyle={{
                          width: "fit-content",
                        }}
                      />
                      )}
                      <div>
                        {`${record?.tenant_product_info?.ref_product_code ? `${record?.tenant_product_info?.ref_product_code} - ` : ''}${record?.tenant_product_info?.alias_name}`?.trim()}
                      </div>
                    </Fragment>
                  ) : (
                    <div>
                      <BomSelector
                        hideTitle
                        emptyNotAllowed
                        tenantDepartmentId={rmTenantDepartmentId}
                        selectedBom={record?.bom_id}
                        placeholder="Select Bill of Material.."
                        onChange={(value) => handleProductChange(record?.key, value)}
                        disabled={(!rmTenantDepartmentId) || record?.bom_id}
                        labelClassName="mo-form__input-row__label"
                        inputClassName="input"
                        excludedProducts={excludedProducts || []}
                        includeInActiveBOM
                        tenantId={selectedTenant}
                      />
                    </div>
                  )
                }
              </div>
            );
          },
        },
        {
          title: 'READY TO PRODUCE',
          width: '150px',
          render: (text, record) => {
            const { getReadyToProduce } = this.props;
            return (record?.bom_id && Number(getReadyToProduce(record?.tenant_product_info?.tenant_product_id)) > 0) ? `${getReadyToProduce(record?.tenant_product_info?.tenant_product_id)} ${record?.tenant_product_info?.uom_info?.uqc?.toProperCase() || record?.bom_info?.product_info?.uom_info?.uqc?.toProperCase()}` : '-'
          }
        },
        {
          title: 'QUANTITY',
          width: '146px',
          render: (text, record) => {
            const {
              createMOLoading, updateMOLoading, formSubmitted, handleQuantityChange,
            } = this.props;
            return (
              <Fragment>
                {record?.bom_id
                  ? (
                    <div className="mo-fg-table__quantity">
                      <H3FormInput
                        name="a valid quantity"
                        type="number"
                        containerClassName="orgInputContainer mo-form__input-row__input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput input"
                        placeholder=""
                        onChange={(e) => {
                          handleQuantityChange(record?.tenant_product_info?.tenant_product_id, parseFloat(e.target.value), record?.key);
                        }}
                        value={record?.quantity}
                        showError={formSubmitted && ((!Number(record?.quantity)))}
                        disabled={createMOLoading || updateMOLoading}
                        loading={createMOLoading || updateMOLoading}
                      />
                      <H3Text
                        text={record?.tenant_product_info?.uom_info?.uqc?.toProperCase()}
                        className="mo-fg-table__quantity-unit"
                      />
                    </div>
                  ) : '-'}
              </Fragment>
            );
          },
        },
        {
          title: 'BATCH INFO',
          width: '250px',
          render: (item) => {
            const { user, tenantDepartmentId, data, updateData, formSubmitted, setIsBatchValid } = this.props;

            const enabledLocationBasedStock = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
            const enabledWarehouseLocations = user?.tenant_info?.global_config?.sub_modules?.warehouse_setup?.is_active;

            return (
              <FGInwardBatch
                item={item}
                formSubmitted={formSubmitted}
                data={data}
                updateData={(value) => updateData(value)}
                destDepartmentId={tenantDepartmentId}
                enabledWarehouseLocations={enabledWarehouseLocations && enabledLocationBasedStock}
                setIsBatchValid={setIsBatchValid}
                hideCost
              />
            );
          },
        },
        {
          title: 'BATCH CUSTOM FIELDS',
          width: '236px',
          render: (item) => {

            const { formSubmitted, } = this.props;
            
            return (
              <Fragment>
                <BatchCustomFields
                  cfWrapperClassName="create-grn__input-row"
                  labelClassName="create-grn__input-row__label"
                  customFields={item?.selectedBatch?.custom_fields || []}
                  formSubmitted={formSubmitted}
                  customInputChange={(value, cfId) => this.updateBatchCfs(value, cfId, item)}
                  isHorizontalUi
                  hideTitle
                />
              </Fragment>
            )
          },
        },
        // {
        //   title: 'RM COST PER UNIT',
        //   width: '150px',
        //   render: (text, record) => (record?.bom_id ? `${this.props.MONEY(this.props.getFgCosting(record?.tenant_product_info?.tenant_product_id, Number(record?.quantity))?.rmCostPerUnit)}` : '-'),
        // },
        // {
        //   title: 'CHARGES PER UNIT',
        //   width: '150px',
        //   render: (text, record) => (record?.bom_id ? `${this.props.MONEY(this.props.getFgCosting(record?.tenant_product_info?.tenant_product_id, Number(record?.quantity))?.chargePerUnit)}` : '-'),
        // },
        {
          title: 'TOTAL UNIT COST',
          width: '150px',
          render: (text, record) => (record?.bom_id ? ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view total unit  cost"} /> : `${this.props.MONEY(this.props.getFgCosting(record?.tenant_product_info?.tenant_product_id, Number(record?.quantity))?.totalCostPerUnit)}`) : '-'),
        },
        {
          title: 'TOTAL COST',
          width: '150px',
          render: (text, record) => (record?.bom_id ? ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view total cost"} /> : `${this.props.MONEY(this.props.getFgCosting(record?.tenant_product_info?.tenant_product_id, Number(record?.quantity))?.totalCostPerUnit * record?.quantity)}`) : '-'),
        },
        {
          title: ' ',
          width: '40px',
          render: (text, record) => {
            const { handleDelete } = this.props;
            return (
              <Popconfirm
                title={<div style={{ width: '250px' }}>Raw materials, by products and charges associated with this FG will also be removed. Are you sure?</div>}
                onConfirm={() => handleDelete(record.key)}
                onCancel={() => { }}
                okText="Yes"
                cancelText="No"
                placement="topLeft"
                className="mp-fg__delete-line-button-confirm"
              >
                <div className="mp-fg__delete-line-button">
                  <CloseOutlined />
                </div>
              </Popconfirm>
            );
          },
        },
      ],
      includeInActiveBOM: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    const newData = JSON.parse(JSON.stringify(data));
    return newData;
  }

  updateBatchCfs = (fieldValue, cfId, record) => {
    
    const { data, updateData, } = this.props;
    const copyData = JSON.parse(JSON.stringify(data));

    for (const item of copyData) {

      if(record?.key === item?.key && item?.key) {

        const copyLineCfs = item?.selectedBatch?.custom_fields;
        for (const cf of copyLineCfs) {
          
          if (cf.cfId === cfId) {

            cf.fieldValue = cf.fieldType === 'ATTACHMENT' ? fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url,
              type: attachment?.type,
              name: attachment?.name,
              uid: attachment?.uid,
            })) : fieldValue;
            break;
          }
        }
        break;
      }
    }
    updateData(copyData);
  };

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data, loading, isFlexible,
    } = this.props;
    const {
      productListColumns,
    } = this.state;
    return (
      <Fragment>
        <div className="mo-fg-table-wrapper hide__in-mobile">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            scroll={{ x: true }}
            columns={isFlexible ? productListColumns : productListColumns?.filter((item) => item.title)}
            dataSource={this.getDataSource(data)}
            pagination={false}
          />
        </div>

      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

FinishedGood.propTypes = {
  loading: PropTypes.bool,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  moQuantity: PropTypes.any,
  isFlexible: PropTypes.bool,
  handleQuantityChange: PropTypes.func,
  createMOLoading: PropTypes.bool,
  updateMOLoading: PropTypes.bool,
  getFgCosting: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FinishedGood));
